import React from "react";

import "../assets/styles/comments.scss";

export default function Comments() {
	return <section className="comments"></section>;
}
